module.exports = __webpack_public_path__ + "img/header.2e6c7dfa.png";